import React from 'react';

function BetbookAnalysisShareIcon({ fill = '#fff', className = '', width = undefined, height = undefined }) {
    return (
        <svg
            className={'icon betbook-analysis-share-icon ' + className}
            width={width}
            height={height}
            fill={fill}
            viewBox="0 0 20 20"
        >
            <path d="M10 0c5.523 0 10 4.477 10 10 0 2.084-.638 4.02-1.729 5.622l1.68 3.523a.625.625 0 0 1-.691.845l-4.884-.996A9.96 9.96 0 0 1 10 20C4.477 20 0 15.523 0 10S4.477 0 10 0Zm0 1.5a8.5 8.5 0 0 0 0 17 8.46 8.46 0 0 0 3.719-.854 1.5 1.5 0 0 1 .794-.146l.163.024 3.147.642-.906-1.899a1.5 1.5 0 0 1 .032-1.354l.082-.135A8.453 8.453 0 0 0 18.5 10 8.5 8.5 0 0 0 10 1.5ZM5.5 8.75a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Zm9 0a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Zm-4.5 0a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Z" />
        </svg>
    );
}

export default BetbookAnalysisShareIcon;
